import * as types from '../../mutation_type'
export default {
  [types.QUERYCODEINFO] (state, res) {
    state.selProvinces = res.data.data
  },
  [types.GETADDRESSCITY] (state, res) {
    state.selCity = res.data.data
  },
  [types.GETADDRESSAREA] (state, res) {
    state.selArea = res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/modules/cardProject/mutations/mutation.js